<template>
	<Modal width="md" @requestUnmount="$emit('safeToUnmount')">
		<template #header>
			<div class="font-semibold text-lg mb-2">{{ $t('Remove from classroom') }}</div>
		</template>

		<template #default="modalActions">
			<div class="px-2 py-4">
				<div v-if="errorMessage" class="alert alert-error text-sm mb-4">
					{{ errorMessage }}
				</div>

				<p class="text-danger">
					<i18n-t keypath="Are you sure you want to remove the {count} selected pupils from the classroom {name}?" tag="span">
						<template #count>
							<strong>{{ selectedPupils.length }}</strong>
						</template>
						<template #name>
							"<strong>{{ currentClassroom.name }}</strong>"
						</template>
					</i18n-t>
					<!-- {{ confirmDescription }} -->
				</p>
			</div>

			<div class="modal-footer flex justify-end gap-2 mt-2 overflow-hidden">
				<button type="button" class="btn btn-ghost" @click="modalActions.hide">{{ $t('Cancel') }}</button>
				<button
					type="button"
					class="btn btn-primary"
					:class="{ 'btn-disabled': processing }"
					@click="confirm(modalActions)"
				>
					<span v-if="processing" class="loading loading-spinner loading-sm"></span>
					{{ $t('Confirm') }}
				</button>
			</div>
		</template>
	</Modal>
</template>

<script lang="ts">
import Modal from "@/components/ui/Modal.vue";
import { mapStores } from "pinia";
import { usePupilsStore } from "@/stores/Pupils.store";
import { ApiErrorMessageBag } from "@/stores/errors/ApiErrorMessageBag";
import { Pupil } from "@/models/Pupil.model";
import { Classroom } from "@/models/Classroom.model";
import type { PropType } from 'vue';

export default {
	name: "PupilBulkRemoveModal",

	components: {
		Modal,
	},

	props: {
		selectedPupils: {
			type: Array as PropType<Pupil[]>,
			required: true,
		},
		currentClassroom: {
			type: Object as PropType<Classroom>,
			required: true,
		},
	},

	emits: ["safeToUnmount", "removed"],

	data() {
		return {
			processing: false,
			errorMessage: null as string | null,
		};
	},

	computed: {
		...mapStores(usePupilsStore),

		// confirmDescription(): string {
		// 	return this.$t('Are you sure you want to remove the {count} selected pupils from the classroom "{name}"?', {
		// 		count: this.selectedPupils.length,
		// 		name: this.currentClassroom.name,
		// 	});
		// },
	},

	methods: {
		async confirm(modalActions: any) {
			if (this.processing) return;

			this.errorMessage = null;
			this.processing = true;
			try {
				await this.pupilsStore.bulkRemoveFromClassroom(this.selectedPupils, this.currentClassroom);
				this.$notify({ text: this.$t('The pupils have been removed from the classroom'), type: 'success' });
				this.$emit('removed');
				modalActions.hide();
			} catch (e: any) {
				this.errorMessage = e instanceof ApiErrorMessageBag
					? e.toString()
					: this.$t('An error occurred');
			} finally {
				this.processing = false;
			}
		},
	},
};
</script>
